export class ApiRequest {
  data: any;
  constructor(data: any) {
    this.data = data;
  }
}
